import React, { useState } from "react";

import Iconify from "../../iconify";
import IconCode from "@/src/lib/iconCode";
import CustomIconButton from "@/src/lib/ui/iconButton";

const MarqueeWithClose = ({ announcement }) => {
    // State for managing marquee visibility
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="marquee-container bg-primary">
            <div className="marquee-wrapper">
                <p
                    className="marquee-content text-sm text-white"
                    dangerouslySetInnerHTML={{
                        __html: announcement?.announcement,
                    }}
                ></p>
                <p
                    className="marquee-content text-sm text-white"
                    dangerouslySetInnerHTML={{
                        __html: announcement?.announcement,
                    }}
                ></p>
            </div>
            <CustomIconButton
                className="absolute top-0 right-0 w-10 h-10 bg-primary"
                variant="contained"
                color="secondary"
                size="small"
                onClick={handleClose}
                aria-label="Close announcement"
            >
                <Iconify
                    icon={IconCode.close}
                    className="text-white"
                    width={50}
                />
            </CustomIconButton>
        </div>
    );
};

export default MarqueeWithClose;
